import { render, staticRenderFns } from "./aliPayDialog.vue?vue&type=template&id=2d2060e9&scoped=true"
import script from "./aliPayDialog.vue?vue&type=script&lang=js"
export * from "./aliPayDialog.vue?vue&type=script&lang=js"
import style0 from "./aliPayDialog.vue?vue&type=style&index=0&id=2d2060e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2060e9",
  null
  
)

export default component.exports